import { render, staticRenderFns } from "./Csat.vue?vue&type=template&id=0c8d1013"
import script from "./Csat.vue?vue&type=script&lang=js"
export * from "./Csat.vue?vue&type=script&lang=js"
import style0 from "./Csat.vue?vue&type=style&index=0&id=0c8d1013&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports